import {UseSocketOptions} from 'socket.io-react-hook/lib/cjs/types';

import {SocketNamespace} from 'enums';
import {UserDataStorage} from 'services/UserData';

import {platformUtils} from './../utils/platform';
import {useNamespaceSocket} from './namespace-socket';

export const useUserSocket = <T>(jwt: string, options?: UseSocketOptions<T>) =>
    useNamespaceSocket(SocketNamespace.Users, {
        ...options,
        enabled: !!jwt && options.enabled,
        auth: {
            token: jwt,
            ...platformUtils.getPlatformInfo(),
            sessionId: UserDataStorage.getItem()?.sessionId
        }
    });